import type { Dispatch, ReactElement } from "react";
import { Fragment, useCallback } from "react";
import { FilterActionTypes, type LocationFilterAction } from "./filter-reducer";
import type { OpenFilterArgs } from "./filters";
import { GeometryFilterChipGroup } from "./geometry-filter/chip-group";
import type { LocalLocationFilterWithId, LocationFilterType } from "./types";

export interface FilterChipGroupProps {
  handleOpenFilter: (args: OpenFilterArgs<LocationFilterType>) => void;
  dispatchFilter: Dispatch<LocationFilterAction>;
}

export const LocationFilterChipGroup = ({
  filters,
  dispatchFilter,
  ...props
}: FilterChipGroupProps & {
  selectFilter?: LocationFilterType;
  filters: Array<LocalLocationFilterWithId>;
}): ReactElement => {
  const deleteFilter = useCallback(
    (id: string) => {
      dispatchFilter({
        type: FilterActionTypes.DELETE_FILTER,
        payload: { id },
      });
    },
    [dispatchFilter],
  );

  return (
    <>
      {filters.map((filter) => (
        <Fragment key={filter.id}>
          <GeometryFilterChipGroup
            filter={filter.geometry}
            id={filter.id}
            handleDelete={deleteFilter}
            {...props}
          />
        </Fragment>
      ))}
    </>
  );
};
